import { supabase } from "../../services/supabase";
import { RUTA_CREAR_CONTRASENA } from "../auth/authService";

// Cuentas y roles en Supabase (Configuración → Usuarios y Roles, solo administradores).
// Las lecturas pasan por las reglas RLS y las funciones SQL; los cambios de cuentas, por la Edge Function
// usuarios-admin (con la clave secreta).

function lanzar(error, porDefecto) {
  if (!error) return;
  if (/roles_nombre_key|duplicate key/i.test(error.message || "")) throw new Error("Ya existe un rol con ese nombre");
  if (/al menos un administrador/i.test(error.message || "")) throw new Error("Debe quedar al menos un administrador activo");
  if (/usuarios_rol_id_fkey|foreign key/i.test(error.message || "")) throw new Error("El rol tiene cuentas: pásalas a otro rol primero");
  throw new Error(error.message || porDefecto);
}

export async function listarCuentas() {
  const { data, error } = await supabase.rpc("usuarios_detalle");
  lanzar(error, "No se pudieron cargar las cuentas");
  return data || [];
}

export async function personasSinCuenta() {
  const { data, error } = await supabase.rpc("miembros_sin_cuenta");
  lanzar(error, "No se pudieron cargar las personas");
  return data || [];
}

export async function listarRoles() {
  const { data, error } = await supabase.from("roles").select("*").order("nombre");
  lanzar(error, "No se pudieron cargar los roles");
  return data || [];
}

export async function guardarRol(id, datos) {
  const consulta = id ? supabase.from("roles").update(datos).eq("id", id) : supabase.from("roles").insert(datos);
  const { error } = await consulta;
  lanzar(error, "No se pudo guardar el rol");
}

export async function eliminarRol(id) {
  const { error } = await supabase.from("roles").delete().eq("id", id);
  lanzar(error, "No se pudo eliminar el rol");
}

// Llama a usuarios-admin y devuelve su respuesta; si falla, lanza el mensaje que ella explica.
export async function accionCuenta(accion, datos = {}) {
  const { data, error } = await supabase.functions.invoke("usuarios-admin", {
    body: { accion, ...datos, redirect: `${window.location.origin}${RUTA_CREAR_CONTRASENA}` },
  });
  if (error) {
    const detalle = await error.context?.json?.().catch(() => null);
    throw new Error(detalle?.error || "No se pudo completar la acción. Inténtalo de nuevo.");
  }
  return data;
}
